import { Text, Input, Stack } from '@pairy/pds-react';
import { KeyboardEvent, ReactNode } from 'react';

import { FORM_VALIDATIONS } from '../../../../constant/formValidations';
import RequiredMark from '../RequiredMark';
import { FormRecordProps } from '../index.type';
import * as Styled from '../index.styles';

interface Props extends FormRecordProps<string> {
  type?: HTMLInputElement['type'];
  title: string;
  description?: string;
  placeholder: string;
  isRequired: boolean;
  actionButton?: (isInvalid: boolean) => ReactNode;
  readOnly?: boolean;
}

const FormInput = ({
  type = 'text',
  title,
  id,
  description,
  placeholder,
  isRequired,
  translateKoToEn,
  handleChangeWithId,
  value,
  actionButton,
  readOnly,
}: Props) => {
  const isEmpty = isRequired && value?.trim() === '';

  const isInvalidEmail =
    type === 'email' &&
    !FORM_VALIDATIONS.email.pattern.value.test(value as string) &&
    Boolean(value);

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.stopPropagation();
    }
  };

  return (
    <Stack direction="column" gap={4}>
      <Stack gap={4} alignItems="center">
        <Styled.KeepAllText variant="md-semibold" color="black">
          {title}
        </Styled.KeepAllText>
        {isRequired && <RequiredMark translateKoToEn={translateKoToEn} />}
      </Stack>
      {description && (
        <Styled.KeepAllText variant="sm-medium" color="zinc_400">
          {description}
        </Styled.KeepAllText>
      )}

      <Stack direction="row" gap={8} alignItems="center">
        <Input
          width="100%"
          type={type}
          placeholder={placeholder}
          isError={type === 'email' ? isInvalidEmail || isEmpty : isEmpty}
          onChange={(e) => {
            handleChangeWithId(id, e.target.value);
          }}
          onKeyDown={handleKeyDown}
          value={value}
          readOnly={readOnly}
        />
        {actionButton &&
          actionButton(type === 'email' ? isInvalidEmail || isEmpty : isEmpty)}
      </Stack>

      {type === 'email' && isInvalidEmail && (
        <Text variant="sm-medium" color="cerise_500">
          {translateKoToEn('invalid-email-message')}
        </Text>
      )}
      {isEmpty && (
        <Text variant="sm-medium" color="cerise_500">
          {translateKoToEn('required-field')}
        </Text>
      )}
    </Stack>
  );
};

export default FormInput;
